export default {
    // url: 'https://nls4elmur9.execute-api.ap-northeast-1.amazonaws.com/API-Hpa27-Test/hpa27-web'
    url: 'https://c6ftz5z7za.execute-api.ap-northeast-1.amazonaws.com/V1/'
}